import { useEffect } from "react"
import { useRouter } from "next/router"
import { ECommerceState } from "../_common/machines/ecommerce-machine/e-commerce-machine"
import { goto } from "../../_common/routing"

export const useGoToPayment = (state: ECommerceState) => {
    const router = useRouter()

    const readyToCheckout = state.matches("flow.checkout.validated")
    useEffect(() => {
        if (readyToCheckout) {
            goto(router, state.context.flowVersion.router.route("payment"))
        }
    }, [readyToCheckout, router])
}
